import type { ReactNode } from "react";
import { twMerge } from "@/lib/twMerge";

/** A selectable row in a sidebar list (the browse pages' side lists).
 * Selected state is a sunken background plus a left brand-colored "spine" (an inset
 * box-shadow, not a solid highlight or arrow) — matches registry-editor.html's
 * `.row.sel { background:var(--sunken); box-shadow: inset 2px 0 0 var(--brand); }`
 * rather than the solid accent-tinted highlight a component library default would use. */
export function ListRow({
  selected,
  onClick,
  children,
}: {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        "w-full rounded px-2.5 py-2 text-left text-sm hover:bg-sunken",
        selected && "bg-sunken shadow-[inset_2px_0_0_var(--color-brand)]",
      )}
    >
      {children}
    </button>
  );
}
